/**
 * Constants for the users feature
 */

/**
 * ATEK organisation ID
 * Used to determine if an org is the internal ATEK org
 */
export const ATEK_ORG_ID = '5c474958930f4e00113a160d';

/**
 * Base tags available for ATEK org users
 */
export const ATEK_ORG_BASE_TAGS = ['Sales Manager', 'Quality Manager'];

/**
 * Customer-facing account tags available to internal ATEK staff.
 */
export const CUSTOMER_ACCOUNT_TAGS = [
  'Contractual Manager',
  'IT Manager',
  'Technical Manager',
  'Quality Manager',
];

/**
 * Tags available for customer organisations with calibration services
 */
export const CUSTOMER_CALIBRATION_TAGS = [
  'Calibration Technician',
  'Calibration Supervisor',
  'Quality Manager',
];

export interface OrgFeatureFlags {
  auditorRole?: boolean;
  customerManagedCalibration?: boolean;
}

export function getOrgFeatureFlags(): OrgFeatureFlags {
  if (typeof window === 'undefined') return {};

  return (
    (
      window as Window & {
        orgFeatureFlags?: OrgFeatureFlags;
      }
    ).orgFeatureFlags || {}
  );
}
